import React, { ChangeEvent, FC, useId } from 'react';

import classNames from 'classnames';

import cls from './FileInput.module.css';
import { Icon } from '../Icon/Icon';

export enum FileInputTheme {
    PRIMARY = 'primary',
    LIGHT = 'light',
}

interface FileInputProps {
    classes?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    buttonText: string;
    theme?: FileInputTheme;
    accept?: string;
    id?: string;
}

export const FileInput: FC<FileInputProps> = ({
    onChange,
    classes,
    buttonText,
    theme = FileInputTheme.PRIMARY,
    accept,
    id,
}) => {
    const generatedId = useId();
    const inputId = id || generatedId;

    return (
        <div className={classNames(cls.fieldFileWrapper, [classes])}>
            <input
                onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e)}
                name="file"
                type="file"
                id={inputId}
                accept={accept}
                className={classNames(cls.fieldFile)}
                multiple
            />
            <label className={classNames(cls.fieldFileWrapper)} htmlFor={inputId}>
                <div className={classNames(cls.fieldFileButton, cls[theme])}>
                    <Icon
                        iconName="plus"
                        color={theme === FileInputTheme.PRIMARY ? '#fff' : '#252733'}
                    />
                    {buttonText}
                </div>
            </label>
        </div>
    );
};
